import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const INVENTORY_SETTINGS_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('INVENTORY_SETTINGS');
export const INVENTORY_SETTINGS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	INVENTORY_SETTINGS_CRUD_ACTION_CONSTANTS
);
